import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { QAList, type Question } from '../_components/QAList';
const courseQuestions: Question[] = [{
  title: 'Na jakiej platformie odbywają się zajęcia online?',
  content: <>
        Zarówno kursy grupowe jak i spotkania z mentorami odbywają się za pomocą platformy{' '}
        <a href='https://discord.com' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Discord
        </a>
        . Każdy uczeń otrzymuje link do serwera, poprzez który świadczymy wszystkie usługi naszej
        firmy.
      </>
}, {
  title: 'Jak mogę zapisać się na pierwsze zajęcia?',
  content: <>
        Formularz zapisu dostępny jest na podstronie interesującego Cię kursu. Wszystkie aktywne
        kursy możesz zobaczyć na stronie{' '}
        <Link href='/kursy' className='font-semibold text-algoprimary'>
          kursy
        </Link>
        . Jeśli natomiast interesuje Cię mentoring możesz umówić się na{' '}
        <Link href='/bezplatna-konsultacja' className='font-semibold text-algoprimary'>
          bezpłatną konsultację
        </Link>{' '}
        lub wybrać odpowiadającą Ci formę mentoringu na stronie{' '}
        <Link href='/cennik' className='font-semibold text-algoprimary'>
          cennika
        </Link>
        . Po dokonaniu zakupu nasz mentor skontaktuje się z Tobą w celu ustalenia szczegółów.
      </>
}, {
  title: 'Czy zajęcia są dostępne stacjonarnie?',
  content: 'W trosce o jak najszerszą dostępność naszych usług w całej Polsce, kursy grupowe prowadzimy wyłącznie w formie zdalnej.'
}, {
  title: 'Czy zajęcia grupowe są nagrywane?',
  content: <>
        Tak, nagrywamy zajęcia - to pomaga nam kontrolować jakość i zapewnić Tobie możliwość
        powtórzenia treści lekcji. Nagrania są tylko dla Was (uczestników kursu) i naszego zespołu.
        Nie udostępniamy ich nikomu innemu.
      </>
}, {
  title: 'Czy jest możliwość zrezygnowania z nagrywania zajęć?',
  content: 'Niestety nie ma możliwości zrezygnowania z nagrywania zajęć w kursach grupowych. W szczególnych przypadkach po wcześniejszym zgłoszeniu takiej potrzeby możemy wyciąć fragmenty nagrań lub całkowicie usunąć nagranie.'
}, {
  title: 'Jakie są koszty kursów?',
  content: <>
        Koszty zależą od tematu kursu, poziomu zaawansowania i wielkości grupy. Wszystkie dostepne
        kursy wraz z ich cenami możesz zobaczyć na podstronie{' '}
        <Link href='/cennik' className='font-semibold text-algoprimary'>
          cennika
        </Link>
        .
      </>
}, {
  title: 'Jakie technologie i języki programowania są nauczane na zajęciach?',
  content: <>
        Szczegółowe informacje o technologiach, których uczymy, znajdziesz na stronie{' '}
        <Link href='/technologie' className='font-semibold text-algoprimary'>
          technologii
        </Link>
        . Jeśli chcesz poszerzyć swoją wiedzę w innym obszarze zachęcamy do zapoznania się z ofertą{' '}
        <Link href='/mentoring' className='font-semibold text-algoprimary'>
          mentoringu
        </Link>
        .
      </>
}, {
  title: 'Czy mogę zmienić nauczyciela prowadzącego kurs?',
  content: <>
        W mentoringu - oczywiście! W kursach grupowych też jest to możliwe, ale tylko w wyjątkowych
        sytuacjach (np. gdy nauczyciel długotrwale nie może prowadzić zajęć). Wtedy szybko
        znajdziemy kogoś równie dobrego, kto pasuje do poziomu i charakteru Waszej grupy.
      </>
}, {
  title: 'Jakie są wymagania techniczne do uczestnictwa w zajęciach?',
  content: <>
        Potrzebujesz komputera, który obsłuży{' '}
        <a href='https://discord.com' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          Discord
        </a>{' '}
        - to wszystko! Sprawdź szczegóły na{' '}
        <a href='https://support.discord.com/hc/pl/articles/213491697-Jakie-są-wymagania-systemu-operacyjnego-dla-Discorda' className='font-bold text-algoprimary hover:underline' target='_blank' rel='noopener noreferrer'>
          stronie Discord
        </a>
        . Przyda się też mikrofon i kamera, żebyśmy mogli się słyszeć i widzieć.
      </>
}, {
  title: 'Jaki jest maksymalny limit uczestników kursu?',
  content: <>
        Limit uczestników znajdziesz na stronie każdego kursu. Zazwyczaj nie zwiększamy liczby
        miejsc, żeby każdy miał szansę na indywidualne podejście od nauczyciela.
      </>
}, {
  title: 'Do kiedy mogę się zapisać na kurs grupowy?',
  content: <>
        Zapisy na dane zajęcia grupowe odbywają się, co do zasady, do 14 dni przed planowaną datą
        rozpoczęcia danego kursu.
      </>
}];
export function QACourseSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={courseQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}